import React, { useState } from 'react';
import cx from 'classnames';
import { InputElement } from './TextArea.styles';
import FeedbackError from '@/components/form/FeedbackError/FeedbackError';
import HelperText from '@/components/form/HelperText/HelperText';
import MaxLengthConter from '@/components/form/MaxLengthConter/MaxLengthConter';

export interface TextAreaProps {
  id?: string;
  name: string;
  className?: string;
  error?: string;
  placeholder?: React.TextareaHTMLAttributes<HTMLTextAreaElement>['placeholder'];
  cols?: React.TextareaHTMLAttributes<HTMLTextAreaElement>['cols'];
  rows?: React.TextareaHTMLAttributes<HTMLTextAreaElement>['rows'];
  maxLength?: React.TextareaHTMLAttributes<HTMLTextAreaElement>['maxLength'];
  helperText?: string;
  showCounter?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ name, error, className, helperText, showCounter, ...props }: TextAreaProps, ref) => {
    const [counter, setCounter] = useState(0);

    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      if (typeof props.onChange === 'function') {
        props.onChange(event);
      }

      if (showCounter && props.maxLength) {
        setCounter(() => event.target.value.length);
      }
    };

    return (
      <>
        <InputElement
          ref={ref}
          name={name}
          className={cx(
            {
              'is-invalid': error,
            },
            className
          )}
          {...props}
          onChange={handleChange}
        />
        {(showCounter && props?.maxLength && (
          <MaxLengthConter counter={props.maxLength - counter}>
            <FeedbackError error={error} />
            <HelperText text={helperText} />
          </MaxLengthConter>
        )) || (
          <>
            <FeedbackError error={error} />
            <HelperText text={helperText} />
          </>
        )}
      </>
    );
  }
);

TextArea.displayName = 'TextArea';

export default TextArea;
